import React from "react";

const LocalizationMap = () => {
  return (
    <div style={{ overflow: "hidden", width: "80%", margin: "3rem auto" }}>
      <div style={{ position: "relative", paddingBottom: "56.25%", height: 0, overflow: "hidden" }}>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2513.394784794444!2d18.57404017679641!3d54.39498897261194!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46fd75279ee94f15%3A0x61628f83a1c81e68!2sWydzia%C5%82%20Biologii%20Uniwersytetu%20Gda%C5%84skiego!5e1!3m2!1spl!2spl!4v1779789408268!5m2!1spl!2spl"
          style={{
            border: 0,
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%"
          }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Wydział Biologii Uniwersytetu Gdańskiego"
        ></iframe>
      </div>
    </div>
  );
};

export default LocalizationMap;